import { Progress } from "antd";
import React from "react";

function AttemptSummary({ data }) {
  const percentage =
    (data?.testStatus?.result?.totalCorrectAnswers /
      data?.testStatus?.result?.totalQuestion) *
    100;
  return (
    <div className="space-y-5">
      <h1 className="text-lg font-semibold">Attempt Summary</h1>
      <p>
        Distribution of questions attempted in a total of{" "}
        {data?.testStatus?.result?.totalQuestion} question(s).
      </p>
      <div className="flex gap-10">
        <div className="text-center">
          <Progress
            size={250}
            strokeColor={"#FF6B38"}
            type="circle"
            percent={percentage}
            gapDegree={180}
            gapPosition="bottom"
            format={(percent) => (
              <h1 className="text-2xl">
                {`${data?.testStatus?.result?.totalQuestion} Total Question`}
              </h1>
            )}
          />
          <p className="-mt-10 font-semibold">
            This shows the correctness of questions attempted by the test taker
          </p>
        </div>
        <table className="text-left w-full">
          <tr className="border-b-2">
            <th>
              <div className="flex items-center gap-3">
                <div className="w-[15px] h-[15px] bg-[#F9814D] rounded" />
                Correct
              </div>
            </th>
            <td>{data?.testStatus?.result?.totalCorrectAnswers} Ques</td>
            <td>
              {data?.testStatus?.result?.totalMarks}/
              {data?.testStatus?.result?.maxMarks} Marks
            </td>
          </tr>
          <tr className="border-b-2">
            <th>
              <div className="flex items-center gap-3">
                <div className="w-[15px] h-[15px] bg-[#A2A2A2] rounded" />
                Incorrect
              </div>
            </th>
            <td>
              {data?.testStatus?.result?.totalQuestion -
                data?.testStatus?.result?.totalCorrectAnswers}{" "}
              Ques
            </td>
            <td>
              {data?.testStatus?.result?.totalMarks}/
              {data?.testStatus?.result?.maxMarks} Marks
            </td>
          </tr>
          <tr className="border-b-2">
            <th>
              <div className="flex items-center gap-3">
                <div className="w-[15px] h-[15px] bg-[#1592E6] rounded" />
                Partially Correct
              </div>
            </th>
            <td>0 Ques</td>
            <td>0/0 Marks</td>
          </tr>
          <tr className="border-b-2">
            <th>
              <div className="flex items-center gap-3">
                <div className="w-[15px] h-[15px] bg-[#DEE6EE] rounded" />
                Not Attempted
              </div>
            </th>
            <td>0 Ques</td>
            <td>0/0 Marks</td>
          </tr>
        </table>
      </div>
    </div>
  );
}

export default AttemptSummary;
